import { USER_ROLE, isAdminRole, getEffectiveDashboardRole } from "./authSession";

export { USER_ROLE };

export function getPostLoginPath(role) {
  if (isAdminRole(role)) {
    return "/dashboard/admin";
  }
  return "/dashboard/client";
}

/** True when a usable session (token + role) exists in this browser. */
export function isAuthenticated() {
  if (typeof window === "undefined") return false;
  return (
    Boolean(window.localStorage.getItem("repman_access_token")) &&
    Boolean(getEffectiveDashboardRole())
  );
}

/**
 * Where a "Back to login" control on a dual-use auth page (forgot/reset
 * password) should lead: the dashboard when already signed in, otherwise the
 * login screen.
 */
export function getGuestReturnPath() {
  if (isAuthenticated()) {
    return getPostLoginPath(getEffectiveDashboardRole());
  }
  return "/anmelden";
}
